import * as Sentry from "@sentry/react";
import {useQueryClient} from "@tanstack/react-query";
import {ModalsProvider} from "@mantine/modals";
import {Notifications} from "@mantine/notifications";

import {useEffect} from "react";
import Footer from "./components/Footer/Footer.jsx";
import LoaderScreen from "./components/Loader/LoaderScreen";
import AuthRoutes from "./pages/auth/AuthRoutes.jsx";
import LoginPage from './pages/auth/LoginPage';
import {BrowserRouter, Route, Routes} from 'react-router';
import AuthorizePage from './pages/auth/AuthProcessPage';
import SharedRoute from "./pages/auth/SharedRoute";
import Charts from "./pages/charts/Charts";
import HerdFest from "./pages/event/HerdFest.jsx";
import BrowserExtension from "./pages/meta/BrowserExtension";
import CreditsPage from "./pages/meta/Credits.jsx";
import TestPage from "./pages/meta/Test.jsx";
import DiscordTimestamp from "./pages/misc/DiscordTimestamp/DiscordTimestamp";
import TournamentCounter from "./pages/misc/TournamentCounter";
import api, {useUser} from "./utils/api";
import {VersionUpdateNotification} from "./components/VersionUpdateNotification";
import {startAnalytics} from "./utils/analytics";

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

function App() {
    const {user, factions, analyticsId, isLoading} = useUser();
    const queryClient = useQueryClient();

    useEffect(() => {
        api.interceptors.response.use((r) => r, (error) => {
            if (error.response && error.response.statusText) {
                //alertError('Error', error.response.statusText);
                if (error.response.status === 401) {
                    Sentry.withScope((scope) => {
                        scope.setFingerprint(["401-error"]);
                        scope.setLevel("debug"); // Reduce severity
                    });
                    queryClient.invalidateQueries(['user'])
                }
                if (error.response.status === 503) {
                    Sentry.withScope((scope) => {
                        scope.setFingerprint(["503-error-maintenance"]);
                        scope.setLevel("debug"); // Reduce severity
                    });
                }
            }
            return Promise.reject(error);
        })
    }, []);

    useEffect(() => {
        if (!isLoading) {
            startAnalytics(user, factions, analyticsId);
        }
    }, [isLoading, user, factions, analyticsId]);

    if (isLoading) {
        return <LoaderScreen message="Loading character"/>
    }

    return (
        <ModalsProvider>
            <Notifications position="top-right" pauseResetOnHover="notification"/>
                <BrowserRouter>
                    <div className="screen">
                        <div className="content">
                            <SentryRoutes>
                                <Route path="/authorize" exact element={<AuthorizePage/>}/>
                                {/*<Route path="/login" exact element={<LoginPage/>}/>*/}
                                <Route path="/credits" exact element={<CreditsPage/>}/>
                                <Route path="/test" exact element={<TestPage/>}/>
                                <Route path="/herdfest" exact element={<HerdFest/>}/>
                                <Route path="/charts" element={<SharedRoute component={Charts}/>}/>
                                <Route path="/charts/:tab" element={<SharedRoute component={Charts}/>}/>

                                <Route path="/misc/browser-extension" element={<SharedRoute component={BrowserExtension}/>}/>
                                <Route path="/misc/timestamp" element={<SharedRoute component={DiscordTimestamp}/>}/>
                                <Route path="/misc/tournament" element={<SharedRoute component={TournamentCounter}/>}/>
                                <Route path="*" element={user ? <AuthRoutes/> : <LoginPage/>}/>
                            </SentryRoutes>
                        </div>
                        {/*<Footer/>*/}
                        <VersionUpdateNotification/>
                    </div>
                </BrowserRouter>
        </ModalsProvider>
    )
}

export default App
